export function getView(note_id, edited_note) {
  return note_id === edited_note.id && edited_note.state === 'update'
    ? 'Edit'
    : 'Read'
}
